
<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>Engfinity Club Installation Press Release</h1>
                </div>
            </div>
        </div>
    </div>
 </section>
 <section class="section-lg std-scholarship">
    <div class="container">
        <div class="row justify-content-between align-items-center">
            <div class="col-lg-7 text-justify">
            <p>The Engfinity Club Installation for the students of BCCA, BCA, BCom and BSc (all streams) in G H Raisoni College of Commerce Science & Technology took place with great fervor and enthusiasm recently.
            </p>
            <p>The club is meant for the enhancement of the basic English communication skills, public speaking, stage confidence and LSRW Skills among students of the college.
            </p>
            <p>The installation ceremony consisted of formal announcement of the club restructuring, Guest speeches, demonstration meet, extempore competition and fun filled language games and activities.
            </p>
            </div>
            <div class="col-lg-5">
                <div class="team" >
                    <figure class="mb-0"><img src="assets/images/blogs/engfinity-club-installation-press-release.webp" class="card-img-top" alt="Engfinity Club Installation Press Release | Ghrcacsn" title="Engfinity Club Installation Press Release | Ghrcacsn" /></figure>
                </div>
            </div>
            <div class="col-lg-12">
               <div class="text-justify mt-3">
                    <p>The Chief guest of the event, Ms Salama Anjum, Associate Professor, Director, Ascendant Learning Centre Ltd, motivated all the students with her insightful words of wisdom.
                    </p>
                    <p>The event was blessed with the presence of the Director Raisoni Business School Dr. Aarti Deshpande. She praised the dedication of the teachers and students for setting the benchmark with the superb performances through this club time and again.
                    </p>
                    <p>The club incharge Prof. Kalyani Dubey threw light upon the overall journey of Engfinity club so far and inspired the students to keep ahead the spirit alive.  
                    </p>
                    <p>The event was prominently attended by Dean Students' Activities & Progression and principal Dr. Jasvinder Kaur along with HODs and other staff members.
                    </p>
                    <p>The event was witnessed and appreciated by all students in huge numbers. The Program was a grand success.   
                    </p>
               </div>
            </div>
        </div>
    </div>
 </section>
 